export default class Software {

  constructor(software = {}) {
    this.id = software.id || null
    this.name = software.name || null
    this.cpe_identifier = software.cpe_identifier || null
    this.cpe_classification = software.cpe_classification || null
    this.version_regex = software.version_regex || `/(\d+(\.\d+){2})(\-[\w\d\.\-]*)?(\+[\w\d\.\-]*)?/`
    this.attribute_type_id = software.attribute_type_id || null
    this.last_cpe_update = software.last_cpe_update || null
    this.can_be_updated = software.can_be_updated || false
    this.latest_version = software.latest_version || null
    this.distributions = software.distributions || []
  }

  mutations() {
    return {
      setSoftware: (state, software) => state.software = new Software(software),
      clearSoftware: (state) => state.software = new Software(),
      updateName: (state, name) => state.software.name = name,
      updateAppMeta: (state, meta) => state.software.attribute_type_id = meta,
      toggleCanBeUpdated: (state) => state.software.can_be_updated = !state.software.can_be_updated,
      updateCpeIndentifier: (state, cpe_identifier) => state.software.cpe_identifier = cpe_identifier,
      updateCpeClassification: (state, cpe_classification) => state.software.cpe_classification = cpe_classification,
      updateVersionRegex: (state, version_regex) => state.software.version_regex = version_regex,
      setDistributions: (state, distributions) => state.software.distributions = distributions,
    }
  }

}